
import { formatDate } from "@/lib/utils";

interface PerformanceDataTableProps {
  performanceData: {
    date: string;
    performance_value: number;
    index_measures?: string;
  }[];
}

const PerformanceDataTable = ({ performanceData }: PerformanceDataTableProps) => {
  if ((performanceData?.length || 0) === 0) return null;

  // Sort data by date in descending order
  const sortedData = [...performanceData].sort((a, b) => {
    // Sort by date descending
    const dateComparison = new Date(b.date).getTime() - new Date(a.date).getTime();
    if (dateComparison !== 0) return dateComparison;
    
    // For same date, put YTD first if index_measures is available
    if (a.index_measures === 'ytd' && b.index_measures !== 'ytd') return -1;
    if (a.index_measures !== 'ytd' && b.index_measures === 'ytd') return 1;
    return 0;
  });

  // Group data by year for better visualization
  const groupedByYear = sortedData.reduce((acc, record) => {
    const year = new Date(record.date).getFullYear();
    if (!acc[year]) {
      acc[year] = [];
    }
    acc[year].push(record);
    return acc;
  }, {} as Record<string, typeof performanceData>);

  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <h3 className="text-navy-dark font-semibold mb-2">Historical Performance Data</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr>
              <th className="px-4 py-2">Year</th>
              <th className="px-4 py-2">Date</th>
              <th className="px-4 py-2">Type</th>
              <th className="px-4 py-2">Value</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(groupedByYear).map(([year, records]) => (
              records.map((record, index) => (
                <tr key={`${year}-${index}`} className={index === 0 ? "border-t border-gray-200" : ""}>
                  {index === 0 ? (
                    <td className="px-4 py-2 font-semibold">{year}</td>
                  ) : (
                    <td className="px-4 py-2"></td>
                  )}
                  <td className="px-4 py-2">{formatDate(record.date)}</td>
                  <td className="px-4 py-2">{record.index_measures?.toUpperCase() || 'Monthly'}</td>
                  <td className="px-4 py-2">{record.performance_value.toFixed(2)}%</td>
                </tr>
              ))
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PerformanceDataTable;
